import React from 'react';
import CreateContent from "./create-content.jsx";
import UpdateContent from "./update-content.jsx";

const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const AuditContent = ({element}) => {
    return (
        <table className="table report-table mb-4 audit-content-table">
            <thead style={{background: "#F2F2F2"}}>
                <tr className='text-left'>
                    <th style={{width: "15%"}}>ID</th>
                    <th style={{width: "15%"}}>Ação</th>
                    <th style={{width: "25%"}}>Agente</th>
                    <th style={{width: "55%"}}>Data/hora</th>
                </tr>
            </thead>

            <tbody>
                <tr className='text-left'>
                    <td><a href={`${BASENAME}${API_DESPACHO_WEB}/schedule-attendance/form/${element?.id}`} target="_blank" rel="noreferrer" className={'report-link'}>{element?.id}</a></td>
                    <td>{element?.action}</td>
                    <td>{element?.user}</td>
                    <td>{element?.date}</td>
                </tr>

                {element?.action !== "Visualização" && (
                    ((element?.action === 'Cadastro' || element?.action === 'Exclusão') ? <CreateContent element={element}/> : <UpdateContent element={element}/>) ?? ''
                )}
            </tbody>
        </table>
    );
};

export default AuditContent;